import { render, staticRenderFns } from "./SettingsRadio.vue?vue&type=template&id=0bebfcca&"
import script from "./SettingsRadio.vue?vue&type=script&lang=js&"
export * from "./SettingsRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bebfcca')) {
      api.createRecord('0bebfcca', component.options)
    } else {
      api.reload('0bebfcca', component.options)
    }
    module.hot.accept("./SettingsRadio.vue?vue&type=template&id=0bebfcca&", function () {
      api.rerender('0bebfcca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Settings/SettingsRadio.vue"
export default component.exports